import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { TCarouselSlideFields } from '../../@shared/galleryCarousel/types/mediaCarousel.types';
import { GalleryCarouselProps, TFullscreenCarouselFields } from '../types/productModelDetailFullScreenMediaGallery.types';

export class ProductModelDetailFullScreenMediaGalleryModel {
  private readonly fields?: TFullscreenCarouselFields | null;
  private readonly rendering?: ComponentRendering;

  constructor(props: GalleryCarouselProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get slides(): Array<TCarouselSlideFields> {
    if (this.fields?.apiData?.assets && this.fields?.apiData?.assets?.length > 0) {
      return (
        this.fields?.apiData?.assets?.map((item) => {
          return {
            fields: {
              description: {
                value: appendRootToRichTextInternalLinks(item?.description),
              },
              productImageProps: {
                desktopRendition: item?.rendition_desktop_size1900,
                desktopSDRendition: item?.rendition_desktop_size1200,
                tabletLandscapeRendition: item?.rendition_tablet_size1000,
                tabletRendition: item?.rendition_tablet_size1200,
                mobileRendition: item?.rendition_mobile_size1100,
              },
              video: {
                value: {
                  href: item?.full || '',
                  linktype: '',
                  target: '',
                  id: '',
                },
              },
              useVideo: {
                value: (item?.role === 'video' || item.role === 'extvideo') && !!item.full,
              },
            },
          };
        }) || []
      );
    }
    return [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
